import { MachineDetails } from 'app/models/api/machines';
import { EquipmentDetailsDto } from '@festo-ax/smartenance-shared-ui';

export class SapSynchronizationUtils {
  public static ShouldLoadSapEquipment(
    sapEquipmentId: string | null,
    isSapMachine: boolean,
    sapConnectorAgreementAccepted: boolean,
    hasSapConnectorLicense: boolean,
    sapEquipment: EquipmentDetailsDto): boolean {

    const sapEquipmentIdHasBeenRetrieved: boolean = sapEquipment?.id === sapEquipmentId;
    const isSapEquipmentAvailable: boolean = hasSapConnectorLicense && sapConnectorAgreementAccepted && isSapMachine && sapEquipmentId != null;
    return isSapEquipmentAvailable && !sapEquipmentIdHasBeenRetrieved;
  }

  static IsSapFunctionalityAvailableForMachine(machine: MachineDetails | null, isSapConnectorAgreementAccepted: boolean, hasSapConnectorLicense: boolean): boolean {
    const isSapMachine: boolean = machine?.isSapMachine ?? false;
    return hasSapConnectorLicense && isSapMachine && isSapConnectorAgreementAccepted;
  }
}
